export const AcademicStage = {
  PrePrimary: 'pre_primary',
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary'
} as const;

export type AcademicStage = (typeof AcademicStage)[keyof typeof AcademicStage];
